import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { UserService } from './user.service';

const ALLOWED_STREAM_OWNER_ACTIONS = [ 'DELETE_ITEMS', 'MANAGE_ANNOTATIONS', 'MANAGE_STREAM', 'EMAIL_TO_STREAM', 'DELETE_COMMENTS', 'POST_TO_STREAM', 'VIEW_STREAM'];

const userHasPermittedTenantAction = (user, action) => user.tenantRoleActions ?
    _.some(user.tenantRoleActions, tenantRole => _.includes(tenantRole.actions, action)) :
    false;

const userHasPermittedStreamAction = (user, action, streamId) => user.streamRoleActions ?
    _.some(user.streamRoleActions, role => _.includes(role.actions, action) && role.streamId === streamId) :
    false;

const userIsStreamOwnerAndHasPermission = (user, action, streamOwnerId) => user.id === streamOwnerId &&
    ((userHasPermittedTenantAction(user, 'CREATE_STREAM') && _.includes(ALLOWED_STREAM_OWNER_ACTIONS, action)) || userHasPermittedTenantAction(user, action));

@Injectable({ providedIn: 'root' })
export class PermissionService {
    constructor(private userService: UserService){}

    currentUserHasPermission = (options: {streamId ?: any, 
        action: string, 
        streamOwnerId ?: any, 
        userId ?: any, 
        passNoUserThrough ?: boolean}) => this.userHasPermission(this.userService.getCurrentUser(), options);

    currentUserCanRead =  (stream, defaultVal, preventTenantOverride?) => 
        !stream ? defaultVal : stream.openForReading || this.userHasPermission(this.userService.getCurrentUser(), { action: 'VIEW_STREAM', streamId: stream.id, streamOwnerId: stream.ownerId, preventTenantOverride: preventTenantOverride });

    currentUserIsStreamManager(): boolean {
        return this.currentUserHasPermission({ action: 'MANAGE_STREAM' });
    }

    currentUserIsStreamCreator(): boolean {
        return this.currentUserHasPermission({ action: 'CREATE_STREAM' });
    }

    currentUserCanCreateStream(): boolean {
        return this.currentUserIsStreamCreator() || this.currentUserIsStreamManager();
    }

    currentUserCanManageStream(stream): boolean {
        const ownerIsEditing = this.currentUserHasPermission({ action: 'MANAGE_STREAM', streamOwnerId: stream.ownerId });
        const isTenantStreamManager = this.currentUserHasPermission({ action: 'MANAGE_STREAM' });
        const hasStreamLevelPermission = this.currentUserHasPermission({ action: 'MANAGE_STREAM', streamId: stream.id });

        return ownerIsEditing || isTenantStreamManager || hasStreamLevelPermission;
    }

    userHasPermission = (user, options: {streamId ?: any, 
                                         action: string, 
                                         streamOwnerId ?: any, 
                                         userId ?: any,
                                         preventTenantOverride ?: boolean, 
                                         passNoUserThrough ?: boolean}) => {
        if(user && user.id) {
            return (userHasPermittedTenantAction(user, options.action) && !options.preventTenantOverride) ||
                userHasPermittedStreamAction(user, options.action, options.streamId) ||
                userIsStreamOwnerAndHasPermission(user, options.action, options.streamOwnerId) ||
                (user.id === options.userId && !options.streamOwnerId);
        } else {
            return options && options.passNoUserThrough ? true : false;
        }
    };

    userHasTenantAction(user, action) {
        return userHasPermittedTenantAction(user, action);        
    }
}
